module.exports = __webpack_public_path__ + "static/101_home-642be2ae1858c0d14783b2c9121abf88.png";